const components = {
  MuiButton: {
    defaultProps: {
      disableElevation: true,
      variant: "contained",
      size: "medium",
    },
    styleOverrides: {
      root: {
        borderRadius: 10,
        textTransform: "none",
        fontWeight: 600,
      },
    },
    variants: [
      {
        props: { size: "medium" },
        style: {
          minHeight: 44,
          padding: "8px 16px",
          fontSize: "0.875rem",
        },
      },
      {
        props: { size: "large" },
        style: {
          minHeight: 56,
          padding: "12px 24px",
          fontSize: "1rem",
        },
      },
    ],
  },

  MuiCard: {
    styleOverrides: {
      root: {
        borderRadius: 16,
        boxShadow: "0 10px 30px rgba(0,0,0,0.08)",
      },
    },
  },

  MuiPaper: {
    styleOverrides: {
      root: {
        borderRadius: 16,
      },
    },
  },

  MuiTextField: {
    defaultProps: {
      variant: "outlined",
      size: "small",
      fullWidth: true,
    },
  },
};

export default components;
